export default "__VITE_ASSET__DMpGD0yp__"